import {FunctionComponent} from 'react';

export const InputSlider: FunctionComponent<React.HTMLProps<HTMLInputElement>> = props => (
  <input
    className='w-full max-w-inputSlider h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer'
    type='range'
    {...props}
  />
);
